import React from 'react';
import { useChat } from '../chat/ChatContext';

export default function ChatUnreadBadge() {
  const { state } = useChat();
  const total = React.useMemo(() => {
    try {
      const chats = state?.chats || {};
      const sum = Object.values(chats).reduce((acc, c) => acc + (c && c.unread ? c.unread : 0), 0);
      return sum > 999 ? 999 : sum;
    } catch (_) { return 0; }
  }, [state?.chats]);
  if (total <= 0) return null;
  return (
    <span className="app-badge-count">
      {total > 99 ? '99+' : total}
    </span>
  );
}
